import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Assets from '../../../Assets/Assets';
import { PostAPI } from "../../../ApiServices/ApiServices";
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";


const NewPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [eyeOpen, setEyeOpen] = useState(false);
    const [eyeOpenTwo, setEyeOpenTwo] = useState(false);
    const [error, setError] = useState('');

    const validatePasswords = () => {
        if (!newPassword || !confirmPassword) {
            setError("Please enter both password fields.");
            return false;
        }
        if (newPassword.length < 6) {
            setError("Password must be at least 6 characters long.");
            return false;
        }
        if (newPassword !== confirmPassword) {
            setError("Passwords do not match!");
            return false;
        }

        setError('');
        return true;
    };




    const resetPassword = () => {
        if (!validatePasswords()) return; // Only proceed if validation passes

        const data = { email, new_password: newPassword, confirm_password: confirmPassword };

        PostAPI({ url: "/change_password", data }, (response) => {
            console.log("Reset Password Response:", response);
            if (response?.status === 1) {
                toast.success("Password reset successfully!", { autoClose: 1500 });
                navigate('/');
            } else {
                setError(response?.message || "Failed to reset password.");
            }
        });
    };


    return (
        <div className='login-form container'>
            <div className='right-content'>
                <h4 className='form-head color-txt'>Reset Password</h4>
                <h4 className='form-head'>Set your New Password</h4>
            </div>
            <div className='form-box'>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <Form>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>New Password <span style={{color: "var(--red)"  }}>*</span></Form.Label>
                        <div className='eye-setup'>
                            <Form.Control type={eyeOpen ? 'text' : 'password'}
                                placeholder="Enter New Password"
                                className='login-input'
                                value={newPassword}
                                onChange={(e) => {
                                    setNewPassword(e.target.value);
                                    validatePasswords();
                                }}
                            />
                            <img src={eyeOpen ? Assets.eyeOpen : Assets.eyeClose} alt="eye-image" className='eye-img' onClick={() => setEyeOpen(!eyeOpen)} />
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Confirm New Password <span style={{color: "var(--red)"  }}>*</span></Form.Label>
                        <div className='eye-setup'>
                            <Form.Control type={eyeOpenTwo ? 'text' : 'password'}
                                placeholder="Enter Confirm Password"
                                className='login-input'
                                value={confirmPassword}
                                onChange={(e) => {
                                    setConfirmPassword(e.target.value);
                                    validatePasswords(); // Revalidate on change
                                }}
                            />
                            <img src={eyeOpenTwo ? Assets.eyeOpen : Assets.eyeClose} alt="eye-image" className='eye-img' onClick={() => setEyeOpenTwo(!eyeOpenTwo)} />
                        </div>
                    </Form.Group>
                    <Button variant="primary" onClick={resetPassword} className='mb-3'>
                        Confirm
                    </Button>
                </Form>
            </div>

        </div>
    )
}

export default NewPassword